import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-alert-success',
    templateUrl: './alert-success.component.html',
    styleUrls: ['./alert-success.component.scss'],
    standalone: false
})
export class AlertSuccessComponent {

  @Input() isSmall: boolean = false;
}
